import { useEffect } from "react";
import { readBoardPreference, writeBoardPreference } from "./boardPreferences";

export type BoardViewName = "kanban" | "schedule";

const PREFERENCE_NAME = "lastView";

/** The kanban is the board's front door, and what everyone had before this. */
const DEFAULT_VIEW: BoardViewName = "kanban";

/**
 * Which of the board's two views was last open.
 *
 * Anything but the two known names — a key written by a future version, or
 * tampered-with storage — falls back rather than routing somewhere that does
 * not exist.
 */
export function readLastBoardView(boardId: string | undefined): BoardViewName {
  return readBoardPreference(boardId, PREFERENCE_NAME) === "schedule"
    ? "schedule"
    : DEFAULT_VIEW;
}

/**
 * Records the view being looked at, so opening the board again returns to it.
 *
 * Recorded on arrival rather than on the toggle, so typing the URL or following
 * a link counts the same as clicking across.
 */
export function useRememberBoardView(
  boardId: string | undefined,
  view: BoardViewName,
): void {
  useEffect(() => {
    writeBoardPreference(boardId, PREFERENCE_NAME, view);
  }, [boardId, view]);
}
